import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-picture",
  "use": "icon-picture-usage",
  "viewBox": "0 0 1027 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1027 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-picture\"><defs><style type=\"text/css\"></style></defs><path d=\"M936.96 89.6 87.04 89.6C38.4 89.6 0 128 0 174.08l0 691.2c0 48.64 38.4 87.04 87.04 87.04l852.48 0c48.64 0 87.04-38.4 87.04-87.04l0-691.2C1024 128 985.6 89.6 936.96 89.6zM972.8 865.28c0 17.92-15.36 35.84-35.84 35.84L87.04 901.12c-17.92 0-35.84-15.36-35.84-35.84L51.2 665.6l261.12-220.16 273.92 263.68c10.24 10.24 23.04 10.24 33.28 0l130.56-107.52 215.04 220.16c2.56 2.56 5.12 2.56 7.68 5.12L972.8 865.28zM972.8 757.76l-202.24-207.36c-10.24-10.24-25.6-10.24-35.84-2.56l-130.56 107.52L330.24 394.24c-10.24-10.24-23.04-10.24-33.28 0l-245.76 204.8L51.2 174.08c0-17.92 15.36-35.84 35.84-35.84l852.48 0c17.92 0 35.84 15.36 35.84 35.84L975.36 757.76z\" p-id=\"19470\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/picture.svg
// module id = 3n9f
// module chunks = 68